export enum LicenseStatus {

  ACTIVE,

  INACTIVE

}

export namespace LicenseStatus {

  const MEANINGS = new Map<number, string>([
    [LicenseStatus.ACTIVE, 'Active'],
    [LicenseStatus.INACTIVE, 'Inactive']
  ]);

  export function meaning(status: LicenseStatus) {
    return MEANINGS.get(status);
  }

  export function fromString(name: string): LicenseStatus {
    return LicenseStatus[name];
  }

}
